import Flickity from 'flickity';
import deBounce from 'lodash.debounce';

$(function ($) {
    if (!$(".video-testimonials__carousel").length > 0) {
        return; // not on this page; exit
    }

    // animation init needs to fire before flickity
    setContainerHeights();
    watchClassChanges();
    $(window).on('resize', deBounce(setContainerHeights, 250)); // recalc on window resize
    // end: animation setup calls

    $(".video-testimonials__carousel").each(function () {
        const $carousel = $(this);
        let flkty = null;

        function initializeFlickity() {
            if (flkty) {
                flkty.destroy();
            }

            flkty = new Flickity($carousel[0], {
                wrapAround: true,
                contain: false, // no effect if wrapAround: true
                pageDots: true,
                prevNextButtons: false,
                cellAlign: "center",
                accessibility: false,
                draggable: true,
                adaptiveHeight: true, // adjust height to active slide
            });

            flkty.on("select", function (index) {
                let slide = $carousel.find(".video-testimonials__card-container")
                    .eq(index)
                    .attr("data-slide");
            });

            // insert custom arrows
            let $pageDots = $carousel.find('.flickity-page-dots');
            $pageDots.prepend('<button class="arrow-left" aria-label="Previous"></button>');
            $pageDots.append('<button class="arrow-right" aria-label="Next"></button>');

            $carousel.find('.arrow-left').on('click', function () {
                flkty.previous();
            });

            $carousel.find('.arrow-right').on('click', function () {
                flkty.next();
            });
        }

        function destroyFlickity() {
            if (flkty) {
                flkty.destroy();
                flkty = null;
            }
        }

        function isCarouselNeeded() {
            const cardMarginGap = 16; //1rem

            const carouselWidth = $carousel.width() - cardMarginGap; // cardMarginGap here is for padding
            const contentWidth = $carousel.find(".video-testimonials__card").toArray().reduce((width, card) => width + $(card).outerWidth(true) + cardMarginGap, 0);

            if (contentWidth > carouselWidth) {
                if (!flkty) {
                    destroyPlayers();
                    initializeFlickity();
                }
            } else {
                if (flkty) {
                    destroyPlayers();
                    destroyFlickity();
                }
            }
        }

        isCarouselNeeded();
        $(window).on('resize', deBounce(isCarouselNeeded, 250));
    });

    // -- video thumbnails and auto play/pause
    function pauseVideos() {
        $('.video-testimonials__thumbnail.active').each(function () {
            const $videoWrapper = $(this).closest('.video-testimonials__video-wrapper');
            const $iframe = $videoWrapper.find('iframe');
            if ($iframe[0].src.includes('youtube')) {
                $iframe[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            } else if ($iframe[0].src.includes('vimeo')) {
                $iframe[0].contentWindow.postMessage('{"method":"pause"}', '*');
            }
            $(this).removeClass('active'); // replace thumbnail
        });
    }

    $(document).on('click', function (e) {
        const $clickedElement = $(e.target);
        const $activeCard = $('.video-testimonials__thumbnail.active').closest('.video-testimonials__card');

        // if click was outside active card
        if (!$clickedElement.closest($activeCard).length) {
            pauseVideos();
        }
    });

    $(document).on('click', '.video-testimonials__thumbnail', function (e) {
        e.stopPropagation();
        pauseVideos();

        const $thumbnail = $(this);
        const $videoWrapper = $thumbnail.closest('.video-testimonials__video-wrapper');
        const $card = $videoWrapper.closest('.video-testimonials__card');
        const $iframe = $videoWrapper.find('iframe');

        // hide clicked thumbnail and play video
        $videoWrapper.find('.video-testimonials__thumbnail').addClass('active');

        if ($iframe[0].src.includes('youtube')) {
            initYoutubePlayer($iframe[0]);
            $iframe[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        } else if ($iframe[0].src.includes('vimeo')) {
            initVimeoPlayer($iframe[0]);
            $iframe[0].contentWindow.postMessage('{"method":"play"}', '*');
        }
    });

    // video player events and control
    const pauseTimeout = 3000; // timer to replace thumbnail after video has been paused

    function destroyPlayers() {
        // remove video player APIs when flickity enabled state changes, otherwise YouTube/Vimeo player events (play/pause/etc.) stop working
        // API is re - init on thumbnail click
        $('.video-testimonials__video-wrapper iframe').each(function () {
            var $iframe = $(this);
            var $parent = $iframe.parent();

            var $newIframe = $iframe.clone();

            if (this.ytPlayer) {
                // clear any timeouts
                if (this.ytPlayer.timeoutId) {
                    clearTimeout(this.ytPlayer.timeoutId);
                }

                this.ytPlayer.destroy();
            }

            if (this.vmPlayer) {
                if (this.vmPlayer.timeoutId) {
                    clearTimeout(this.vmPlayer.timeoutId);
                }

                this.vmPlayer.destroy();
            }

            // replace the iframe with the new one
            $iframe.remove();
            $parent.append($newIframe);
        });
    }

    function initVimeoPlayer(iframe) {
        if (!window.Vimeo) {
            loadVimeoAPI(function () {
                setupVimeoPlayer(iframe);
            });
        } else {
            setupVimeoPlayer(iframe);
        }
    }

    function setupVimeoPlayer(iframe) {
        if (!iframe.vmPlayer) {
            iframe.vmPlayer = new Vimeo.Player(iframe);
            var $iframe = $(iframe);
            var $thumbnail = $iframe.closest('.video-testimonials__video-wrapper').find('.video-testimonials__thumbnail');

            iframe.vmPlayer.on('pause', function () {
                if (iframe.vmPlayer.timeoutId) {
                    clearTimeout(iframe.vmPlayer.timeoutId);
                }

                iframe.vmPlayer.timeoutId = setTimeout(function () {
                    iframe.vmPlayer.getPaused().then(function (paused) {
                        if (paused) {
                            $thumbnail.removeClass('active');
                        }
                    });
                }, pauseTimeout);
            });
        }

        return iframe.vmPlayer;
    }

    function loadVimeoAPI(callback) {
        if (typeof callback !== 'function') {
            callback = () => { };
        }

        if (window.Vimeo) {
            callback();
        } else {
            var vimeoScript = document.createElement('script');
            vimeoScript.src = "https://player.vimeo.com/api/player.js";
            vimeoScript.onload = callback;
            document.head.appendChild(vimeoScript);
        }
    }
    loadVimeoAPI();

    function initYoutubePlayer(iframe) {
        if (!window.YT) {
            loadYoutubeAPI(function () {
                setupYoutubePlayer(iframe);
            });
        } else {
            setupYoutubePlayer(iframe);
        }
    }

    function setupYoutubePlayer(iframe) {
        if (!iframe.ytPlayer) {
            iframe.ytPlayer = new YT.Player(iframe, {
                events: {
                    'onStateChange': function (event) {
                        var $iframe = $(iframe);
                        var $thumbnail = $iframe.closest('.video-testimonials__video-wrapper').find('.video-testimonials__thumbnail');
                        if (event.data == YT.PlayerState.PAUSED || event.data == YT.PlayerState.ENDED) {
                            if (iframe.ytPlayer.timeoutId) {
                                clearTimeout(iframe.ytPlayer.timeoutId);
                            }

                            iframe.ytPlayer.timeoutId = setTimeout(function () {
                                if (iframe.ytPlayer.getPlayerState() != YT.PlayerState.PLAYING) {
                                    $thumbnail.removeClass('active');
                                }
                            }, pauseTimeout);
                        }
                    }
                }
            });
        }

        return iframe.ytPlayer;
    }

    function loadYoutubeAPI(callback) {
        if (typeof callback !== 'function') {
            callback = () => { };
        }

        if (window.YT) {
            callback();
        } else {
            window.onYouTubeIframeAPIReady = callback;
            var youtubeScript = document.createElement('script');
            youtubeScript.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(youtubeScript, firstScriptTag);
        }
    }
    loadYoutubeAPI();

    // -- animations
    const cardMaxHeight = '700px';
    function setContainerHeights() {
        $('.video-testimonials').each(function () {
            var $parent = $(this);
            var maxHeight = 0;

            $parent.find('.video-testimonials__card-container').each(function () {
                var $container = $(this);
                var $card = $container.find('.video-testimonials__card');
                var $videoWrapper = $card.find('.video-testimonials__video-wrapper');
                var $content = $card.find('.video-testimonials__content');

                // Calculate full height: video wrapper + content
                var videoWrapperHeight = $videoWrapper.outerHeight();
                var contentHeight = $content.outerHeight();

                var fullHeight = videoWrapperHeight + contentHeight;

                if (fullHeight > maxHeight) {
                    maxHeight = fullHeight;
                }
            });

            // Set all containers within this parent to max height
            $parent.find('.video-testimonials__card-container').height(maxHeight);

            // Set initial card max-height to video wrapper height (for cards that are not open/selected)
            $parent.find('.video-testimonials__card').each(function () {
                var $card = $(this);
                var $container = $card.closest('.video-testimonials__card-container');
                if (!$container.hasClass('is-open')) {
                    var $videoWrapper = $card.find('.video-testimonials__video-wrapper');
                    $card.css('max-height', $videoWrapper.outerHeight());
                }
            });
        });
    }

    function watchClassChanges() {
        $('.video-testimonials__card-container').each(function () {
            var $container = $(this);
            var $card = $container.find('.video-testimonials__card');
            var $videoWrapper = $card.find('.video-testimonials__video-wrapper');

            var observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        if ($container.hasClass('is-open')) {
                            $card.css('max-height', cardMaxHeight);
                        } else {
                            $card.css('max-height', $videoWrapper.outerHeight());
                        }
                    }
                });
            });

            observer.observe($container[0], { attributes: true, attributeFilter: ['class'] });
        });
    }

    // -- open animation on scroll
    let isFirstTime = true;
    function openCardsOnScroll() {
        $('.video-testimonials__card-container:not(.is-open)').each(function () {
            var $container = $(this);
            var containerTop = $container.offset().top;
            var containerBottom = containerTop + $container.outerHeight();
            var windowHeight = $(window).height();
            var scrollTop = $(window).scrollTop();
            var scrollBottom = scrollTop + windowHeight;

            // visible percentage of container
            var visibleHeight = Math.min(containerBottom, scrollBottom) - Math.max(containerTop, scrollTop);
            var visiblePercentage = (visibleHeight / $container.outerHeight()) * 100;
            var isHighlyVisible = visiblePercentage >= 80;

            // is top of card less than x% from viewport top
            var topPercentage = (containerTop - scrollTop) / windowHeight * 100;
            var isTopNearViewport = topPercentage < 40 && topPercentage >= 0;

            if (isHighlyVisible || isTopNearViewport) {
                if (isFirstTime) {
                    // disable animation if already visible on page load
                    $container.addClass('disable-animation').addClass('is-open');
                } else {
                    var randomDelay = Math.random() * 700;
                    setTimeout(function () {
                        $container.addClass('is-open');
                    }, randomDelay);
                }
            }
        });

        isFirstTime = false;
    }

    openCardsOnScroll();
    $(window).on('scroll', openCardsOnScroll);
    $(window).on('resize', deBounce(openCardsOnScroll, 250));
});